/**
 * @generated SignedSource<<f18ea1c28e38201a77041fba40a0ad45>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PhotosSearchBrowsePhotoPreviewModal_photo$data = {
  readonly designFirm: {
    readonly urlLabel: string | null;
  } | null;
  readonly project: {
    readonly name: string | null;
  } | null;
  readonly styles: ReadonlyArray<{
    readonly name: string | null;
    readonly urlLabel: string | null;
  } | null> | null;
  readonly " $fragmentSpreads": FragmentRefs<"PhotosSearchBrowseModalContainer_photo">;
  readonly " $fragmentType": "PhotosSearchBrowsePhotoPreviewModal_photo";
};
export type PhotosSearchBrowsePhotoPreviewModal_photo$key = {
  readonly " $data"?: PhotosSearchBrowsePhotoPreviewModal_photo$data;
  readonly " $fragmentSpreads": FragmentRefs<"PhotosSearchBrowsePhotoPreviewModal_photo">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "urlLabel",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PhotosSearchBrowsePhotoPreviewModal_photo",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PhotosSearchBrowseModalContainer_photo"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "DesignFirm",
      "kind": "LinkedField",
      "name": "designFirm",
      "plural": false,
      "selections": [
        (v0/*:: as any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PhotosSearchBrowsePhotoProject",
      "kind": "LinkedField",
      "name": "project",
      "plural": false,
      "selections": [
        (v1/*:: as any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TradePhotoStyle",
      "kind": "LinkedField",
      "name": "styles",
      "plural": true,
      "selections": [
        (v1/*:: as any*/),
        (v0/*:: as any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "PhotosSearchBrowsePhoto",
  "abstractKey": null
};
})();

(node as any).hash = "2f7a49fd34f12ad186df0490e9487f2a";

export default node;
